import { RootState } from '../rootReducer';
import { IRestaurant } from 'pages/Lunch/Restaurant';

export const getLastUpdate = (state: RootState): Date | string | undefined => state.data.lastUpdate;
export const checkIsDataLoading = (state: RootState): boolean => state.data.isLoading;
export const getRestaurantData = (state: RootState): IRestaurant[] => state.data.restaurants;
export const getDateData = (state: RootState): string[] => state.data.dates;
export const checkHasData = (state: RootState): boolean =>
  state.data.restaurants && state.data.restaurants.length && state.data.dates && state.data.dates.length ? true : false;
